import { Button, FormHelperText, Grid } from '@mui/material';

export const Multiple = ({
  grid,
  options,
  question,
  onChange,
  value,
  ...rest
}) => {
  const onResponse = (val) => {
    let valueSplitted = typeof value === 'string' ? value.split(', ') : [''];
    if (valueSplitted.includes(val)) {
      valueSplitted = valueSplitted.filter((el) => el !== val);
    } else {
      valueSplitted = [...valueSplitted, val];
    }
    onChange(valueSplitted.join(', '));
  };

  return (
    <Grid item className="options-multiple" xs={grid || 12}>
      <Grid container justifyContent="center" spacing={2}>
        <Grid item xs={12}>
          {question}
        </Grid>
        {options.split('\n').map((option) => (
          <Grid key={option} item xs={6} lg={4}>
            <Button
              onClick={() => onResponse(option)}
              style={{ height: '100%' }}
              variant={
                value.split(', ').includes(option) ? 'contained' : 'outlined'
              }
            >
              {option}
            </Button>
          </Grid>
        ))}
      </Grid>
      {rest.error ? (
        <Grid xs={12}>
          <FormHelperText>{rest.helperText}</FormHelperText>
        </Grid>
      ) : null}
    </Grid>
  );
};
